




















































import Vue from 'vue';
import LessonCard from '@/web/components/products/LessonCard.vue';
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import { draggableDelay } from '@/web/utils/draggable';
import LessonEdit from '@/web/components/products/LessonEdit.vue';
import QuizLessonEdit from '@/web/components/products/QuizLessonEdit.vue';

interface LocalState {
  draggableDelay: number;
  isLoading: boolean;
  activeLessonId: null | number;
}

export default Vue.extend({
  name: 'ProductLessons',
  data(): LocalState {
    return {
      draggableDelay,
      isLoading: false,
      activeLessonId: null,
    };
  },
  components: {
    LessonCard,
    LessonEdit,
    QuizLessonEdit,
    draggable,
  },
  computed: {
    ...mapGetters({
      productForm: 'product/productForm',
      teacher: 'user/teacher',
    }),
    lessons: {
      get(): LessonResponse[] {
        return this.productForm.lessons;
      },
      set(values: LessonResponse[]): void {
        values.forEach((v, i) => {
          if (v.position !== i) {
            v.position = i;
            this.update(v);
          }
        });
        this.$store.dispatch('product/setProductForm', {
          ...this.productForm,
          lessons: values,
        });
      },
    },
    productId(): number {
      return parseInt(this.$route.params['id']);
    },
    activeLesson() {
      return this.lessons?.find(({ id }) => this.activeLessonId === id);
    },
  },
  methods: {
    async addLesson(is_quiz_lesson: false): Promise<void> {
      const index = this.productForm.lessons.length;
      let position = 0;
      if (index > 0) {
        position = this.productForm.lessons[index - 1].position + 1;
      }
      this.isLoading = true;
      const lessonResponse = await this.$store.dispatch(
        'product/createProductLesson',
        {
          productId: this.productId,
          data: { position, is_quiz_lesson },
        }
      );
      this.lessons = [...this.lessons, lessonResponse];
      this.selectLesson(lessonResponse.id);
      this.isLoading = false;
    },
    async duplicate(lesson: LessonResponse): Promise<void> {
      this.isLoading = true;
      const content = lesson.content.map(c => c.id);
      const index = this.productForm.lessons.length;
      let position = 0;
      if (index > 0) {
        position = this.productForm.lessons[index - 1].position + 1;
      }
      const lessonResponse = await this.$store.dispatch(
        'product/createProductLesson',
        {
          productId: lesson.product,
          data: {
            lesson_name: lesson.lesson_name,
            lesson_description: lesson.lesson_description,
            lesson_description_new: lesson.lesson_description_new,
            is_quiz_lesson: lesson.is_quiz_lesson,
            content,
            position,
          },
        }
      );
      this.lessons = [...this.lessons, lessonResponse];
      this.activeLessonId = lessonResponse.id;
      this.isLoading = false;
    },
    async remove(lesson: LessonResponse): Promise<void> {
      this.isLoading = true;
      await this.$store.dispatch('product/deleteProductLesson', lesson);
      this.lessons = this.lessons.filter(l => l.id !== lesson.id);
      this.isLoading = false;
    },
    async update(lesson: LessonResponse): Promise<void> {
      const content = lesson.content.map(({ id, position }) => ({
        media_id: id,
        position,
      }));
      this.isLoading = true;
      await this.$store.dispatch('product/updateProductLesson', {
        ...lesson,
        content: lesson.content.map(({ id }) => id),
      });
      await this.$store.dispatch('product/reorderProductLesson', {
        productId: lesson.product,
        lessonId: lesson.id,
        content,
      });
      this.isLoading = false;
    },
    selectLesson(lessonId) {
      this.activeLessonId = lessonId;
    },
  },
  mounted() {
    this.$store.dispatch('quiz/refreshQuizzes');
  },
  watch: {
    lessons: {
      immediate: true,
      handler(lessons) {
        if (lessons.length && !this.activeLesson) {
          this.activeLessonId = lessons[0]?.id;
        }
      },
    },
  },
});
